<template>
  <div :class="classes">
    <pt-page-title :title="hasMedicalReward?'河北医护活动':'奖励汇总'" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey" ref="table"></pt-page-title>
    <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
          <template>
            <el-button type="primary" @click="Filter()">筛选</el-button>
            <el-button type="primary"  @click="exportAllAudit" :loading="exportLoading">导出</el-button>
            <el-button type="primary"  @click="exportHistoryAllAudit">导出历史</el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </template>
      </pt-page-factor-filter>
      <pt-all-audit-table ref="table" :hasMedicalReward="hasMedicalReward" :isFromRouter="isFromRouter" :paramsData="paramsData" :departmentList="departmentList">
      </pt-all-audit-table>
  </div>
</template>

<script>
import { filterLabels, medicalRewardFilterLabels } from './all-audit'
import ptAllAuditTable from './pt-all-audit-table/withData'
import { cashCount } from '@/utils/formUtils'
import { emptyObject } from '@/utils/lifebankUtils'
// 组件class前缀
const prefixCls = 'pt-all-audit'

export default {
  name: 'pt-all-audit',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tableData () {
      return this.$refs.table.tableData
    },
    hasMedicalReward () {
      return this.$route.path === '/doctor-invite-reward'
    }
  },
  components: {
    ptAllAuditTable
  },
  props: {
    exportLoading: {
      type: Boolean,
      default: false
    },
    departmentList: Array
  },
  data () {
    return {
      searchKey: null,
      filterLabels: this.$route.path === '/doctor-invite-reward' ? medicalRewardFilterLabels : filterLabels,
      params: {},
      paramsData: {},
      isFromRouter: false
    }
  },
  watch: {
    departmentList: {
      handler: function (val) {
        if (val && val.length) {
          this.filterLabels.forEach(item => {
            if (item.value === 'businessDepartmentId') {
              item.options = val
            }
          })
        }
      },
      deep: true
    }
  },
  methods: {
    exportAllAudit () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          let params = { ...this.params }
          for (let key in params) {
            if (key === 'rewardMoney') {
              // this.$delete(this.params, 'index')
              params.rewardMoneyMax = cashCount(params[key].rewardMoneyMax)
              params.rewardMoneyMin = cashCount(params[key].rewardMoneyMin)
              // this.params = { ...this.params, ...this.params[key] }
              this.$delete(params, key)
            }
            if (key === 'rewardDate') {
              this.$delete(params[key], 'index')
              params = { ...params, ...params[key] }
              this.$delete(params, key)
            }
          }
          params.searchKey = this.searchKey
          if (this.hasMedicalReward) {
            this.$emit('exportMedicalRewardList', params)
          } else {
            this.$emit('exportAllAudit', params)
          }
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    exportHistoryAllAudit () {
      if (this.hasMedicalReward) {
        this.$router.push('/export-history/medical-reward?name=doctor_invite_reward_export')
      } else {
        this.$router.push('/export-history/all-audit?name=generic_reward_export')
      }
    },
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      // this.paramsData.searchKey = val
      this.$set(this.paramsData, 'searchKey', val)
    },
    emptySearch () {
      this.searchKey = null
      this.$delete(this.paramsData, 'searchKey', null)
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (key === 'rewardMoney') {
          // this.$delete(this.params, 'index')
          this.params.rewardMoneyMax = cashCount(this.params[key].rewardMoneyMax)
          this.params.rewardMoneyMin = cashCount(this.params[key].rewardMoneyMin)
          // this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
        if (key === 'rewardDate') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
      }
      this.paramsData = { ...this.paramsData, ...this.params }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.paramsData)
      }
    },
    cleanParams () {
      emptyObject(this.paramsData)
      emptyObject(this.params)
      this.$refs.filter.getAddRouter(this.paramsData)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
